import { Link as RouterLink } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { Card, Section, PageHero } from "../components/ui";
import { fonts, tokens } from "../theme";

const STEPS = [
  ["Join", "Create your account and choose your membership."],
  ["Book your draw", "Enter your zip code to find a partner lab or an at-home option, then pick a time."],
  ["Get your blood drawn", "A quick visit. Your first visit covers a broad panel; a follow-up comes a few months later."],
  ["Review your results", "Clinician-reviewed results appear in your dashboard with plain-language explanations."],
  ["Follow your plan", "See action items, share a summary with your doctor, and retest to track change."],
];

export default function HowItWorks() {
  return (
    <>
      <PageHero theme="moss" eyebrow="How it works" title="A clear path to care" subtitle="Measure, consult, prescribe, monitor. Nothing rushed. Nothing guesswork. Sample flow: final steps depend on VEYSO's lab and clinical partners." />
      <Section tone="white">
        <Box sx={{ display: "grid", gap: 3 }}>
          {STEPS.map(([t, d], i) => (
            <Card key={t} sx={{ display: "flex", gap: 3, alignItems: "flex-start", background: tokens.cream }}>
              <Typography sx={{ fontFamily: fonts.display, fontSize: 40, color: tokens.forest, minWidth: 44, lineHeight: 1 }}>{i + 1}</Typography>
              <Box>
                <Typography variant="h4" sx={{ fontSize: 22 }}>{t}</Typography>
                <Typography sx={{ color: tokens.muted, mt: .5 }}>{d}</Typography>
              </Box>
            </Card>
          ))}
        </Box>
        <Box sx={{ mt: 5, display: "flex", gap: 2, flexWrap: "wrap" }}>
          <Button variant="contained" component={RouterLink} to="/testing">Start your panel</Button>
          <Button variant="outlined" component={RouterLink} to="/testing/sample-reports">See a sample report</Button>
        </Box>
      </Section>
    </>
  );
}
